import { normalizeTaskStatus } from "./DailyActivityLoggerConstants";

const clampProgress = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;
  return Math.min(100, Math.max(0, Math.round(numeric)));
};

/** Normalize status/progress for API payloads */
export const resolveTaskStatusAndProgress = (status, progressPercent) => {
  const statusValue = normalizeTaskStatus(status);
  const isCompleted = statusValue === "Completed";
  const progress = clampProgress(progressPercent);

  return {
    status: statusValue,
    is_completed: isCompleted,
    progress_percent: isCompleted ? 100 : progress,
  };
};

/** Modal form → update API payload */
export const mapModalFormToUpdatePayload = (formData, context, today) => {
  const isFuture = context === "future";
  const { status, is_completed, progress_percent } = isFuture
    ? { status: "Pending", is_completed: false, progress_percent: 0 }
    : resolveTaskStatusAndProgress(formData.status, formData.progress_percent);

  const payload = {
    description: formData.description || "",
    client_id: formData.client_id ?? null,
    priority: formData.priority || null,
    due_date: isFuture ? formData.scheduled_date || today : today,
    note: formData.outcome ?? null,
    status,
    is_completed,
    progress_percent,
  };

  if (isFuture) {
    payload.log_date = formData.scheduled_date || today;
  }

  return payload;
};

/** Modal form → create API payload */
export const mapModalFormToCreatePayload = (formData, context, today) => {
  const isFuture = context === "future";
  const logDate = isFuture ? formData.scheduled_date || today : today;
  const { status, is_completed, progress_percent } = isFuture
    ? { status: "Pending", is_completed: false, progress_percent: 0 }
    : resolveTaskStatusAndProgress(formData.status, formData.progress_percent);

  return {
    log_date: logDate,
    description: formData.description || "",
    client_id: formData.client_id ?? null,
    priority: formData.priority || null,
    due_date: isFuture ? formData.scheduled_date || logDate : today,
    note: formData.outcome ?? null,
    status,
    is_completed,
    progress_percent,
  };
};

/** Backend → Frontend */
export const mapApiTaskToFrontend = (apiTask) => {
  const completed = Boolean(apiTask.is_completed);
  return {
    id: apiTask.id,
    description: apiTask.description || "",
    priority: apiTask.priority || "",
    outcome: apiTask.note || "",
    client_id: apiTask.client_id || null,
    client: apiTask.client || null,
    application_id: apiTask.application_id || null,
    application_type: apiTask.application_type || null,
    completed,
    completed_at: completed ? apiTask.updated_at : null,
    scheduled_date: apiTask.due_date || apiTask.log_date,
    log_date: apiTask.log_date || null,
    status: normalizeTaskStatus(apiTask.status, completed),
    progress_percent: clampProgress(
      apiTask.progress_percent ?? apiTask.progress ?? 0
    ),
    is_finalized: Boolean(apiTask.is_finalized),
    last_reported_at: apiTask.last_reported_at || null,
    sort_order: apiTask.sort_order ?? 0,
    created_at: apiTask.created_at,
    updated_at: apiTask.updated_at,
  };
};

/** Frontend → Backend */
export const mapFrontendTaskToApi = (task, logDate) => ({
  log_date: logDate,
  description: task.description || "",
  client_id: task.client_id || null,
  priority: task.priority || null,
  due_date: task.scheduled_date || logDate,
  note: task.outcome || null,
  status: task.completed ? "Completed" : task.status || "Pending",
  is_completed: Boolean(task.completed),
  progress_percent: Number(task.progress_percent ?? 0),
});